/**
 * Video
 *
 * Copyright (c) 2020 Aperia Company
 * Released under the MIT license
 */

"use strict";
import { isExists } from "@utils/validate";

/**
 * Video Object
 */
const Video = function (el) {
  const EL_BTN_PLAY = ".btn-play";

  this.initVideo = function () {
    $(EL_BTN_PLAY).on("click", function (e) {
      e.preventDefault();
      $(this).fadeOut();
      $(this).prev().fadeOut();
      $(el).fadeIn();
      let iframe = $(el).find("iframe");
      let video = $(el).find("video");

      if (isExists(iframe)) {
        const node = iframe.get(0);
        if (node && typeof node.src === "string" && node.src.length) {
          const joiner = node.src.includes("?") ? "&" : "?";
          node.src += `${joiner}autoplay=1&rel=0&controls=0&showinfo=0`;
        }
      }
      if (isExists(video)) video.get(0)?.play();
    });
  };

  this.init = function () {
    if (!isExists(el)) {
      return;
    }
    this.initVideo();
  };

  return this.init();
};
export default Video;
